import './hamburger.css';

const MenuIcon = () => {
    function toggleMenu() {
        var element = document.getElementById("menu");
        element.classList.toggle("active");
    }
    return (
        <div className="hamburger">
            <div id="menu" className="menu-icon" onClick={toggleMenu}>
                <div></div>
            </div>
        </div>
    );
}

export default MenuIcon;